<template lang="html">
  <div class="reviews-content">
    <div class="container">
      <div
        v-for="(review, index) in items"
        class="review"
        :key="`review-${index}`">

        <div class="bubble content-bg" v-html="parse(review).review" @click="highlightField('review')"></div>

        <div class="review-author" @click="highlightField('author')">
          <div class="review-initial">{{reviewInitial(parse(review).author)}}</div>
          <h3 class="author-name">{{parse(review).author}}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'Reviews',

  mixins: [parseComponent],

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    reviewInitial() {
      return (author) => {
        let names = author.split(' ')
        let initials = ''

        names.forEach((name) => {
          initials += name.charAt(0)
        })

        return initials
      }
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'

.reviews-content
  max-width: 600px
  margin: auto

  .review
    margin-bottom: $gap-large

  $arrow_size: 15px

  .bubble
    border-radius: 5px
    margin-bottom: $gap-medium
    position: relative
    padding: $gap-small $gap-medium

    &.content-bg
      box-shadow: none

    &:after
      content: ''
      position: absolute
      bottom: -$arrow_size
      left: $gap-large
      width: 0
      height: 0
      border-left: $arrow_size solid transparent
      border-right: $arrow_size solid transparent
      border-top: $arrow_size solid
      color: #fff

  .review-author
    display: flex
    align-items: center

    .author-name
      margin-left: $gap-small

  .review-initial
    width: 45px
    height: 45px
    display: flex
    align-items: center
    justify-content: center
    letter-spacing: 1px
    text-transform: uppercase
    text-align: center
    font-weight: bold
    border-radius: 50%
    padding: $gap-medium
    margin-left: calc(#{$gap-large} - 15px)
    background: #fff
    color: #404040
</style>
